<template lang="pug">
    .category-posts.container(v-if="section.categories")
        .horizontal(v-if="orientation === 'horizontal'")
            loading(:active="loading || fetching" :is-full-page="false" :height="40" :width="40" color="#084375")
            .teasers(v-if="loading")
                .teaser.skeleton(v-for="teaser in teasers" :style="style")
                    .image
                    .text
            .paginated-teasers(v-else)
                .teasers
                    .teaser(v-for="teaser in teasers" :style="style")
                        Teaser(:teaser="teaser" display="card" :hide-image="! showImages")
                Pagination(
                    v-if="pageInfo && pageInfo.lastPage > 1"
                    :last-page="pageInfo.lastPage"
                    :current-page="pageInfo.currentPage"
                    nav-class="pagination is-rounded is-centered"
                    @change="changePage"
                )
                    span.icon(slot="prev")
                        i.fas.fa-arrow-left
                    span.icon(slot="next")
                        i.fas.fa-arrow-right

        .vertical(v-else)
            .column.is-offset-1.is-10
                loading(:active="loading || fetching" :is-full-page="false" :height="40" :width="40" color="#084375")
                .teasers(v-if="loading")
                    .search-input.skeleton
                    .teaser.skeleton(v-for="teaser in teasers")
                        .image
                        .text
                .paginated-teasers
                    .filters(
                        v-if="(teasers && teasers.length) || showFilters"
                        :class="{ 'with-tags': tagOptions.length > 1, 'with-reset-button': filterInput || filterTags.length }"
                    )
                        .control.input-field.has-icons-left
                            .field
                                input.input(
                                    v-model="filterInput"
                                    type="text"
                                    placeholder="Inhalt suchen..."
                                )
                                span.icon.is-small.is-left
                                    i.fas.fa-search
                        .control.tags-field(v-if="tagOptions.length > 1")
                            multiselect(
                                v-model="filterTags"
                                :options="tagOptions"
                                :multiple="true"
                                :loading="loadingTagOptions"
                                track-by="key"
                                label="name"
                                placeholder="Beiträge filtern..."
                                deselect-label="mit Enter abwählen"
                                selected-label="ausgewählt"
                                select-label="mit Enter auswählen"
                            )
                        .control.reset(v-if="filterInput || filterTags.length")
                            button.button.is-light(
                                type="button"
                                @click="resetFilters"
                            ) Filter zurücksetzen
                    .teasers(v-if="teasers && teasers.length")
                        .teaser(v-for="teaser in teasers")
                            Teaser(v-if="teaser" :teaser="teaser" display="row" :hide-image="! showImages")
                        // .teaser.skeleton
                        //     .image
                        //     .text
                    .not-found(v-else)
                        .notification(v-if='filterInput || filterTags.length') Leider gibt es zu Ihrer Suche keine Beiträge.
                        .notification(v-else) Bisher gibt es hier noch keinen Inhalt.
                Pagination(
                    v-if="pageInfo && pageInfo.lastPage > 1"
                    :last-page="pageInfo.lastPage"
                    :current-page="pageInfo.currentPage"
                    nav-class="pagination is-rounded"
                    @change="changePage"
                )
                    span.icon(slot="prev")
                        i.fas.fa-arrow-left
                    span.icon(slot="next")
                        i.fas.fa-arrow-right

</template>

<script>

import _ from 'lodash'
import { mapGetters, mapMutations, mapActions } from 'vuex'

import Loading from 'vue-loading-overlay'
import Multiselect from 'vue-multiselect'
import Teaser from './Teaser'

import Pagination from '@/components/Pagination'

export default {
    name: 'CategoryPosts',
    props: {
        section: {
            type: Object,
            required: true,
        },
        perPage: {
            type: Number,
            default: 15,
        },
        orientation: {
            type: String,
            default: 'vertical',
        },
    },
    data() {
        return {
            fetching: false,
            tagOptions: [],
            loadingTagOptions: false,
            // filters: [],
            showFilters: false,
        }
    },
    components: {
        Loading,
        Teaser,
        Pagination,
        Multiselect,
    },
    watch: {
        filterInput(now, before) {
            const equal = _.isEqual(now, before)
            if (! equal) {
                // this.resetPagination()
                this.debouncedRefetch()
            }
        },
        filterTags(now, before) {
            const equal = _.isEqual(now, before)
            if (! equal) {
                // this.resetPagination()
                this.refetch()
            }
        },
        teasers(teasers) {
            // if there are teasers once (initially) then show filters till component destroyed
            if (teasers.filter(teaser => !!teaser.id).length) this.showFilters = true
        }
    },
    computed: {
        s() {
            return _.findIndex(this.sections, { id: this.section.id })
        },
        loading() {
            return _.get(this.section, 'teasers.loading')
        },
        teasers() {
            let teasers = []
            if (this.loading) {
                if (this.orientation === 'horizontal') teasers = new Array(this.perPage)
                else teasers = new Array(1)
            } else {
                teasers = _.get(this.section, 'teasers.items')
            }

            return teasers
        },
        showImages() {
            let show = true

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'images')
                if (setting && setting.value !== undefined) show = setting.value === 'show'
            }

            return show
        },
        filterInput: {
            get() {
                let value = ''
                const filter = this.filters.find(filter => filter.key === 'full-text')
                if (filter) value = filter.like
                return value
            },
            set(value) {
                let filters = _.cloneDeep(this.filters)

                const i = _.findIndex(filters, filter => filter.key === 'full-text')
                if (i >= 0) {
                    filters[i].like = value
                    this.updateFilter(filters[i])
                } else {
                    const filter = {
                        key: 'full-text',
                        like: value,
                        in: [
                            'category-page-teaser.teaser.text',
                            'heading.heading.title',
                            'heading.heading.sub_title',
                            'post.heading.title',
                            'post.heading.sub_title',
                            'post.content.text',
                        ], // <section>.<content>.<field>
                    }
                    this.addFilter(filter)
                }
            }
        },
        filterTags: {
            get() {
                let tags = []
                const filter = this.filters.find(filter => filter.key === 'tags-user-input')
                if (filter) {
                    tags = this.tagOptions.filter(tag => filter.in.includes(tag.id))
                }
                return tags
            },
            set(tags) {
                let filters = _.cloneDeep(this.filters)

                const i = _.findIndex(filters, filter => filter.key === 'tags-user-input')
                if (i >= 0) {
                    filters[i].in = tags.map(tag => tag.id)
                    this.updateFilter(filters[i])
                } else {
                    const filter = {
                        key: 'tags-user-input',
                        in: tags.map(tag => tag.id),
                    }
                    this.addFilter(filter)
                }
            }
        },
        // showFilters() {
        //     return !! this.filters.filter(filter => filter.key === 'full-text' && filter.like !== '').length
        //         || this.filterTagsUserSelection.length
        // },
        style() {
            return {
                width: `calc(${100 / this.perPage}% - 20px)`
            }
        },
        ...mapGetters('currentPage', {
            sections: 'sections',
            filters: 'filters',
            pageInfo: 'pageInfo',
        }),
        ...mapGetters({
            cms: 'CMS',
        })
    },
    methods: {
        changePage(currentPage) {
            let pageInfo = _.cloneDeep(this.pageInfo)
            pageInfo.currentPage = currentPage
            pageInfo.perPage = this.perPage
            this.insertPageInfo(pageInfo)

            this.refetch()
        },
        refetch() {
            this.fetching = true
            let filters = _.cloneDeep(this.filters)

            // check if the section is limited to some tags
            // and if no tags are selected in filters
            // add default tags to filters

            const tagFilters = filters.find(filter => filter.key === 'tags-user-input')
            if (tagFilters && tagFilters.in.length) {
                filters.map(filter => {
                    if (filter.key === 'tags-user-input') filter.key = 'tags'
                })
            } else if (this.section.tags && this.section.tags.length) {
                filters.push({
                    key: 'tags',
                    in: this.section.tags.map(tag => tag.id)
                })
            }

            const payload = {
                pageInfo: this.pageInfo,
                filters,
            }

            this.fetchTeasers(payload)
                .then(teasers => this.insertTeasers({ s: this.s, teasers }))
                .finally(() => this.fetching = false)
        },
        debouncedRefetch: _.debounce(function() { // function scope is needed here
            this.refetch()
        }, 300),
        resetPagination() {
            let pageInfo = this.pageInfo

            pageInfo.currentPage = 1
            pageInfo.perPage = this.perPage

            this.insertPageInfo(pageInfo)
        },
        resetFilters() {
            this.filterInput = ''
            this.filterTags = []

            this.resetPagination()
            this.refetch()
        },
        ...mapMutations('currentPage', {
            updateTeasersLoading: 'updateCategoryPostTeasersLoading',
            insertTeasers: 'insertCategoryPostTeasers',
            insertFilters: 'insertFilters',
            addFilter: 'addFilter',
            updateFilter: 'updateFilter',
            insertPageInfo: 'insertPageInfo',
        }),
        ...mapActions('currentPage', {
            fetchTeasers: 'fetchCategoryPostTeasers',
            fetchTagOptions: 'fetchTagOptions',
        }),
    },
    mounted() {
        const teasers = { loading: true, pagination: {} }
        this.insertTeasers({ s: this.s, teasers })

        // add tags to multiselect
        if (this.section.tags && this.section.tags.length) {
            this.tagOptions = this.section.tags
        }

        const categories = this.section.categories.map(category => parseInt(category.id))

        if (! this.filters.length) {
            const filters = [{
                key: 'categories',
                in: categories,
            }, {
                key: 'cms',
                match: parseInt(this.cms.id),
            }]
            this.insertFilters(filters)
        }

        // get only relevant tags from server
        // and remove from / add to tagOptions

        this.loadingTagOptions = true
        this.fetchTagOptions({ cms: parseInt(this.cms.id), categories }).then(tags => {
            if (this.tagOptions.length) {
                const tagIDs = tags.map(tag => tag.id)
                this.tagOptions = this.tagOptions.filter(tag => tagIDs.includes(tag.id))
            } else {
                this.tagOptions = tags
            }
        }).finally(() => {
            this.loadingTagOptions = false
        })

        if (! this.pageInfo || ! this.pageInfo.currentPage) {
            const pageInfo = {
                currentPage: 1,
                perPage: this.perPage,
            }
            this.insertPageInfo(pageInfo)
        }

        this.refetch()
    }
}
</script>

<style lang="scss" scoped>

    @import "~bulma/sass/utilities/mixins";
    @import '~empty-state/skeleton';

    @import "~@/assets/sass/variables";

    $skeletonColor: #D8D8D8;
    $topicColor: lighten($primary, 60%);

    .filters {
        width: 100%;
        margin-bottom: 2rem;
        display: flex;
        flex-direction: row;
        .control {
            flex-grow: 1;
            flex-basis: 100%;
            &.reset {
                flex-grow: 0;
                flex-basis: 0;
            }
            + .control {
                margin-left: 1rem;
            }
        }
        // &.with-tags {
        //     display: grid;
        //     grid-template-columns: 1fr 1fr max-content !important;
        //     grid-gap: 1rem;
        // }
    }

    .category-posts /deep/ .pagination-container {
        margin-top: 20px;
        .pagination {
            .pagination-previous,
            .pagination-next {
                padding-left: 0.3em;
                padding-right: 0.3em;
            }
        }
    }

    .category-posts .vertical /deep/ .pagination-container {
        margin-top: 50px;
    }

    .horizontal {
        .teasers {
            text-align: center;
            .teaser {
                margin-bottom: 50px;
                display: inline-block;
                &:last-child {
                    margin-bottom: 10px;
                }
                @include mobile {
                    width: 100% !important;
                    max-width: 360px;
                }

                &.skeleton {
                    .image {
                        padding-bottom: 57%; // ca. 9 / 16
                        background: $skeletonColor;
                        border-radius: 3px;
                    }
                    .text {
                        // $imageHeight: 140px;
                        $imageHeight: 0px;
                        $margin: 20px;
                        $topicHeight: 12px;
                        $headingHeight: 22px;
                        $headingGutter: 6px;
                        $teaserHeight: 12px;
                        $teaserGutter: 4px;

                        $headingLines: 2;
                        $teaserLines: 5;

                        $headingY: $imageHeight + $margin + $topicHeight + $margin;
                        $teaserY: $headingY + $headingLines * ($headingHeight + $headingGutter) - $headingGutter + $margin;

                        $height: $teaserY + $teaserLines * ($teaserHeight + $teaserGutter) - $teaserGutter;

                        $shapes: (
                            // rect(#D8D8D8, 100%, $imageHeight, 0, 0),
                            rect($topicColor, 140px, $topicHeight, 0, $imageHeight + $margin),
                        );

                        $shapes: join($shapes, lines($headingLines, $skeletonColor, 100%, $headingHeight, $headingGutter, 0, $headingY, 60%));
                        $shapes: join($shapes, lines($teaserLines, $skeletonColor, 100%, $teaserHeight, $teaserGutter, 0, $teaserY, 30%));
                        @include skeleton($shapes...);

                        height: $height;
                    }
                }
            }
            @include tablet {
                margin: -10px;
                display: flex;
                flex-direction: row;
                justify-content: center;
                .teaser {
                    margin:  10px;
                    margin-bottom: 10px;
                    flex-grow: 0;
                    flex-shrink: 0;
                }
            }
        }
    }

    .vertical {
        .teasers {
            text-align: center;
            .search-input.skeleton {
                height: 40px;
                margin-bottom: 2rem;
                background: $skeletonColor;
            }
            .teaser {
                margin-bottom: 50px;
                &:last-child {
                    margin-bottom: 10px;
                }
                @include mobile {
                    width: 100% !important;
                    max-width: 360px;
                    display: inline-block;
                }
                &.skeleton {
                    .image {
                        padding-bottom: 57%; // ca. 9 / 16
                        background: $skeletonColor;
                        border-radius: 3px;
                        margin-bottom: 20px;
                        @include tablet {
                            padding-bottom: initial;
                            margin-bottom: 0;
                            height: 180px;
                            width: 320px;
                            flex-basis: 320px;
                            flex-grow: 0;
                            flex-shrink: 0;
                        }
                    }
                    .text {
                        $margin: 20px;
                        $topicHeight: 12px;
                        $headingHeight: 22px;
                        $headingGutter: 6px;
                        $teaserHeight: 12px;
                        $teaserGutter: 4px;

                        $headingLines: 2;
                        $teaserLines: 5;

                        $headingY: $topicHeight + $margin;
                        $teaserY: $headingY + $headingLines * ($headingHeight + $headingGutter) - $headingGutter + $margin;

                        $height: $teaserY + $teaserLines * ($teaserHeight + $teaserGutter) - $teaserGutter;

                        $shapes: (
                            // rect(#D8D8D8, 100%, $imageHeight, 0, 0),
                            rect($topicColor, 140px, $topicHeight, 0, 0),
                        );

                        $shapes: join($shapes, lines($headingLines, $skeletonColor, 100%, $headingHeight, $headingGutter, 0, $headingY, 60%));
                        $shapes: join($shapes, lines($teaserLines, $skeletonColor, 100%, $teaserHeight, $teaserGutter, 0, $teaserY, 30%));
                        @include skeleton($shapes...);

                        height: $height;

                        @include tablet {
                            flex-grow: 1;
                            margin-left: 20px;
                        }
                    }
                    @include tablet {
                        display: flex;
                        flex-direction: row;
                    }
                }
            }
        }
    }

</style>
